(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-personal-plan-root]';
  const TIMER_PREFIX = 'shift_personal_plan_addon_expiry_';
  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;',
  }[character]));

  const TESTIMONIALS = {
    blocked: [
      ['„A tiltás után minden nap azt figyeltem, mikor változik valami. A program abban segített, hogy ne a pánik vezessen, és újra visszakapjam a saját fókuszomat.”', 'Zsófi'],
      ['„A Mentor nem hagyta, hogy másik fiókról ráírjak. Visszaterelt a gyakorlathoz, amikor a leginkább elvesztettem volna a kontrollt.”', 'Bogi'],
      ['„Nem csak affirmációkat kaptam. Pontosan le volt írva, mit tegyek, amikor a csend véglegesnek tűnt.”', 'Kitti'],
    ],
    third_party: [
      ['„Folyamatosan a másik nőhöz hasonlítottam magam. A program segített, hogy ne ez határozza meg minden gondolatomat.”', 'Anna'],
      ['„A Mentor segített különválasztani, amit biztosan tudok attól, amit a félelmem feltételez.”', 'Nóri'],
      ['„A Journal kérdései után először éreztem azt, hogy megint a saját történetemre figyelek.”', 'Dóra'],
    ],
    mixed_signals: [
      ['„Egyik nap közeledett, másnap eltűnt. A program megtanított, hogy ne minden üzenet határozza meg az egész napomat.”', 'Rebeka'],
      ['„A Mentor akkor volt a leghasznosabb, amikor már megint túl akartam elemezni egyetlen mondatát.”', 'Lili'],
      ['„Végre volt egy napi folyamatom, nem csak vártam és figyeltem, hogy mikor történik valami.”', 'Viki'],
    ],
    no_response: [
      ['„A csend alatt folyamatosan rá akartam írni. A napi gyakorlatok adtak valamit, amihez vissza tudtam térni.”', 'Kitti'],
      ['„A legnagyobb különbség az volt, hogy nem maradtam egyedül a kérdéseimmel.”', 'Bogi'],
      ['„A program után sokkal kevésbé éreztem, hogy azonnal választ kell kapnom tőle.”', 'Eszter'],
    ],
    default: [
      ['„Amikor elkezdtem, minden nap rá akartam írni. A program adott egy konkrét kapaszkodót arra az időre, amikor a legnehezebb volt nyugodtnak maradni.”', 'Kitti'],
      ['„A legnagyobb különbség az volt, hogy nem maradtam egyedül a kérdéseimmel. A Mentor segített visszatalálni az aznapi gyakorlathoz.”', 'Bogi'],
      ['„Nem csak affirmációkat kaptam. Pontosan le volt írva, mit tegyek, amikor fájdalmasnak és reménytelennek tűnt a helyzet.”', 'Zsófi'],
    ],
  };

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    let config = {};
    try { config = JSON.parse(root.querySelector('[data-personal-plan-config]')?.textContent || '{}'); } catch (error) { console.error(error); }

    const loading = root.querySelector('[data-plan-loading]');
    const toast = root.querySelector('[data-toast]');
    const addonButton = root.querySelector('[data-addon-toggle]');
    const buyButton = root.querySelector('[data-buy-button]');
    const stickyBuy = root.querySelector('[data-sticky-buy]');
    const stickyBar = root.querySelector('[data-sticky-bar]');
    const offerSection = root.querySelector('#szemelyes-ajanlat');
    const countdown = root.querySelector('[data-countdown]');
    const timerShell = root.querySelector('[data-addon-timer]');
    const planChatOpen = root.querySelector('[data-plan-chat-open]');
    const planChatLayer = root.querySelector('[data-plan-chat-layer]');
    const planChatBody = root.querySelector('[data-plan-chat-body]');
    const planChatForm = root.querySelector('[data-plan-chat-form]');
    const planChatInput = root.querySelector('[data-plan-chat-input]');
    const planChatSend = root.querySelector('[data-plan-chat-send]');
    const planChatRemaining = root.querySelector('[data-plan-chat-remaining]');
    const planChatQuick = root.querySelector('[data-plan-chat-quick]');

    const params = new URLSearchParams(window.location.search);
    const planToken = params.get('plan') || '';
    const state = {
      planToken,
      sessionToken: '',
      addonSelected: false,
      purchasePending: false,
      timerId: 0,
      expiresAt: 0,
      plan: null,
      planChatPending: false,
      planChatHistory: [],
      planChatRemaining: Math.max(1, Number(config.planChatFreeMessages || 3)),
    };

    function showToast(message, duration = 3200) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toast._timer);
      toast._timer = window.setTimeout(() => toast.classList.remove('is-visible'), duration);
    }

    function apiBase() { return String(config.apiBaseUrl || '').trim().replace(/\/$/, ''); }

    async function apiRequest(path, options = {}) {
      const base = apiBase();
      if (!base) throw new Error('API_NOT_CONFIGURED');
      const response = await fetch(`${base}${path}`, {
        cache: 'no-store',
        credentials: 'omit',
        ...options,
        headers: { Accept: 'application/json', ...(options.headers || {}) },
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        const error = new Error(data.error || `HTTP_${response.status}`);
        error.payload = data;
        error.status = response.status;
        throw error;
      }
      return data;
    }

    function setText(selector, value) {
      const node = root.querySelector(selector);
      if (node && value) node.textContent = value;
    }


    function localFallbackPlan() {
      const answers = {
        situation: 'uncertain',
        timeframe: 'unknown',
        contact: 'unknown',
        pain: 'uncertainty',
        goal: 'reconnect',
      };
      return {
        sessionToken: state.sessionToken || '',
        plan: {
          answers,
          assessment: {
            patternTitle: 'A bizonytalanság viszi el a fókuszodat',
            openingInsight: 'A személyes terv betöltése közben biztonsági tartalék mód lépett életbe, ezért most az általános kiinduló tervet látod. A program és a Mentor-hozzáférés ettől még elérhető.',
            mainBlock: 'A fő blokk most az, hogy a bizonytalanság könnyen összekeveri a valódi célodat az azonnali megkönnyebbülés igényével.',
            firstStep: 'A következő 24 órában először állítsd vissza a saját fókuszodat, és csak ezután dönts bármilyen kapcsolatfelvételről.',
            avoidToday: 'Ma ne küldj újabb hosszú, érzelmi üzenetet pusztán azért, hogy azonnali megnyugvást kapj.',
            recommendedReason: 'A program napi kapaszkodót, vezetett e-bookot, ajándék Journalt és Mentor-támogatást ad, hogy ne egyedül próbáld végigvinni az első napokat.',
            mentorOpening: 'Az első napon abban segítek, hogy ne az impulzus vezesse a következő lépésedet, hanem visszakerülj egy stabilabb belső állapotba.',
          },
          personalizationSource: 'local-fallback',
        },
      };
    }

    function renderReviews(plan) {
      const grid = root.querySelector('[data-review-grid]');
      if (!grid) return;
      const situation = plan?.answers?.situation || '';
      const contact = plan?.answers?.contact || '';
      let key = situation;
      if (situation === 'blocked' || contact === 'blocked') key = 'blocked';
      if (!TESTIMONIALS[key]) key = 'default';
      grid.innerHTML = TESTIMONIALS[key].map(([quote, name]) => `
        <article class="pp-review">
          <div>★★★★★</div>
          <p>${escapeHtml(quote)}</p>
          <footer><b>${escapeHtml(name)}</b><span>olvasói visszajelzés</span></footer>
        </article>
      `).join('');
    }

    function applyPlan(data) {
      state.sessionToken = String(data.sessionToken || '');
      state.plan = data.plan || {};
      const assessment = state.plan.assessment || {};
      setText('[data-plan-opening]', assessment.openingInsight);
      setText('[data-plan-pattern]', assessment.patternTitle);
      setText('[data-plan-reason]', assessment.recommendedReason || assessment.mainBlock);
      setText('[data-plan-block]', assessment.mainBlock);
      setText('[data-plan-step]', assessment.firstStep);
      setText('[data-plan-avoid]', assessment.avoidToday);
      setText('[data-mentor-opening]', assessment.mentorOpening);
      setText('[data-offer-reason]', assessment.recommendedReason);
      const chatOpening = root.querySelector('[data-plan-chat-opening]');
      if (chatOpening && assessment.patternTitle) {
        chatOpening.textContent = `Látom, hogy nálad most „${assessment.patternTitle}” a fő kiindulópont. Kérdezhetsz a programról, a hozzáférésről vagy arról, hogyan kapcsolódna a saját helyzetedhez.`;
      }
      renderReviews(state.plan);
    }

    function hideLoading() {
      window.setTimeout(() => loading?.classList.add('is-hidden'), 180);
    }

    async function loadPlan() {
      const designMode = Boolean(window.Shopify?.designMode);
      if (designMode && !planToken) {
        renderReviews({});
        hideLoading();
        return;
      }
      if (!planToken) {
        applyPlan(localFallbackPlan());
        hideLoading();
        return;
      }
      try {
        const data = await apiRequest(`/api/funnel/plan?token=${encodeURIComponent(planToken)}`);
        applyPlan(data);
        trackEvent('personal_plan_viewed', { source: document.referrer || '' });
      } catch (error) {
        console.error('Personal plan load failed; using local fallback plan', error);
        applyPlan(localFallbackPlan());
      } finally {
        hideLoading();
      }
    }


    function updatePlanChatRemaining(value) {
      state.planChatRemaining = Math.max(0, Number(value ?? state.planChatRemaining));
      if (planChatRemaining) planChatRemaining.textContent = String(state.planChatRemaining);
      if (planChatInput) planChatInput.disabled = state.planChatRemaining <= 0;
      if (planChatSend) planChatSend.disabled = state.planChatRemaining <= 0 || !planChatInput?.value.trim();
      if (state.planChatRemaining <= 0 && planChatInput) {
        planChatInput.placeholder = 'A három ingyenes kérdésedet felhasználtad.';
      }
    }

    function scrollPlanChat() {
      window.requestAnimationFrame(() => {
        if (planChatBody) planChatBody.scrollTop = planChatBody.scrollHeight;
      });
    }

    function appendPlanChatMessage(role, text, typing = false) {
      if (!planChatBody) return null;
      const wrapper = document.createElement('div');
      wrapper.className = `pp-mentor-msg pp-mentor-msg--${role}`;
      if (role === 'assistant') {
        wrapper.innerHTML = `<span>S</span><div>${typing ? '<div class="pp-mentor-typing"><i></i><i></i><i></i></div>' : `<p>${escapeHtml(text).replace(/\n/g, '</p><p>')}</p>`}</div>`;
      } else {
        wrapper.innerHTML = `<div><p>${escapeHtml(text)}</p></div>`;
      }
      planChatBody.appendChild(wrapper);
      scrollPlanChat();
      return wrapper;
    }

    function openPlanChat() {
      if (!planChatLayer) return;
      planChatLayer.hidden = false;
      document.documentElement.classList.add('pp-chat-open');
      window.setTimeout(() => planChatLayer.classList.add('is-open'), 10);
      planChatOpen?.classList.remove('has-nudge');
      window.setTimeout(() => planChatInput?.focus(), 260);
      trackEvent('plan_chat_opened', {});
    }

    function closePlanChat() {
      if (!planChatLayer) return;
      planChatLayer.classList.remove('is-open');
      document.documentElement.classList.remove('pp-chat-open');
      window.setTimeout(() => { planChatLayer.hidden = true; }, 260);
    }

    function fallbackPlanChatReply(message) {
      const normalized = String(message || '').toLowerCase();
      if (normalized.includes('lemond')) {
        return 'A havi Mentor-hozzáférés 30 naponta újul meg, és bármikor lemondható. A már megvásárolt 7 napos e-book és a Journal ettől megmarad a könyvtáradban.';
      }
      if (normalized.includes('vásárlás') || normalized.includes('után') || normalized.includes('hozzáfér')) {
        return 'A sikeres Shopify fizetés után aktiváló e-mailt kapsz. Beállítod a jelszavadat, majd a rendszer közvetlenül megnyitja a könyvtáradban a 7 napos e-bookot. A személyes kiindulópontodat nem kell újra elmesélned.';
      }
      if (normalized.includes('e-book') || normalized.includes('ebook') || normalized.includes('más')) {
        return 'A 7 napos e-book adja a teljes folyamatot, de itt nem maradsz egyedül az olvasással: a kiinduló összefoglalód, a Journal és a Mentor együtt segít abban, hogy a gyakorlatokat a saját helyzetedhez tudd kapcsolni.';
      }
      if (normalized.includes('mentor') || normalized.includes('helyzet')) {
        return 'A Mentor látja a beszélgetésből készült kiinduló összefoglalódat, később pedig – a hozzájárulásod szerint – a könyvtárban adott válaszaidat is. Így nem általános sablonból indul, hanem abból, ahol te tartasz.';
      }
      return 'A program célja, hogy a következő hétre egy követhető, nyugodtabb folyamatot adjon, ne pedig még több találgatást. Írd le nyugodtan, mi az a rész, amiben még bizonytalan vagy, és pontosítom.';
    }

    async function sendPlanChat(message) {
      const clean = String(message || '').trim();
      if (!clean || state.planChatPending || state.planChatRemaining <= 0) return;
      state.planChatPending = true;
      planChatQuick?.classList.add('is-used');
      appendPlanChatMessage('user', clean);
      state.planChatHistory.push({ role: 'user', content: clean });
      if (planChatInput) { planChatInput.value = ''; planChatInput.style.height = ''; }
      if (planChatSend) planChatSend.disabled = true;
      const typing = appendPlanChatMessage('assistant', '', true);

      try {
        let reply = '';
        let remaining = Math.max(0, state.planChatRemaining - 1);
        if (!planToken || window.Shopify?.designMode) {
          await new Promise((resolve) => window.setTimeout(resolve, 650));
          reply = fallbackPlanChatReply(clean);
        } else {
          const data = await apiRequest('/api/funnel/plan-chat', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              planToken,
              message: clean,
              history: state.planChatHistory.slice(-7, -1),
            }),
          });
          reply = data.reply || fallbackPlanChatReply(clean);
          remaining = Number.isFinite(Number(data.remaining)) ? Number(data.remaining) : remaining;
        }
        typing?.remove();
        appendPlanChatMessage('assistant', reply);
        state.planChatHistory.push({ role: 'assistant', content: reply });
        updatePlanChatRemaining(remaining);
        trackEvent('plan_chat_message', { remaining });
      } catch (error) {
        typing?.remove();
        const payload = error?.payload || {};
        const reply = payload.reply || (error?.message === 'PLAN_CHAT_LIMIT_REACHED'
          ? 'A három ingyenes kérdésedet felhasználtad. A teljes programban a Mentor már a könyvtárad és a személyes kiindulópontod alapján tud veled tovább dolgozni.'
          : 'Most nem sikerült kapcsolódnom. A program részleteit továbbra is látod az oldalon, vagy próbáld újra egy pillanat múlva.');
        appendPlanChatMessage('assistant', reply);
        if (payload.limitReached || error?.message === 'PLAN_CHAT_LIMIT_REACHED') updatePlanChatRemaining(0);
      } finally {
        state.planChatPending = false;
        if (planChatSend && state.planChatRemaining > 0) planChatSend.disabled = !planChatInput?.value.trim();
      }
    }

    function timerKey() {
      return `${TIMER_PREFIX}${String(planToken || state.sessionToken || 'generic').slice(0, 36)}`;
    }

    function getExpiry() {
      const minutes = Math.max(5, Math.min(30, Number(config.timerMinutes || 15)));
      let expiry = 0;
      try { expiry = Number(sessionStorage.getItem(timerKey()) || 0); } catch (_) {}
      if (!expiry) {
        expiry = Date.now() + minutes * 60 * 1000;
        try { sessionStorage.setItem(timerKey(), String(expiry)); } catch (_) {}
      }
      return expiry;
    }

    function formatCountdown(ms) {
      const total = Math.max(0, Math.ceil(ms / 1000));
      return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
    }

    function startTimer() {
      state.expiresAt = getExpiry();
      const tick = () => {
        const remaining = state.expiresAt - Date.now();
        if (countdown) countdown.textContent = formatCountdown(remaining);
        if (remaining <= 0) {
          window.clearInterval(state.timerId);
          state.addonSelected = false;
          addonButton?.classList.remove('is-active');
          addonButton?.setAttribute('aria-pressed', 'false');
          addonButton?.setAttribute('disabled', 'disabled');
          const label = addonButton?.querySelector('[data-addon-label]');
          if (label) label.textContent = 'Lezárult';
          timerShell?.classList.add('is-expired');
          updatePriceUI();
        }
      };
      tick();
      state.timerId = window.setInterval(tick, 1000);
    }

    function updatePriceUI() {
      const baseMinor = Number(config.mainPriceMinor || 0);
      const mentorMinor = Number(config.mentorPriceMinor || 0);
      // Shopify money strings are authoritative; addon selection is clearly shown separately.
      const addonLabel = addonButton?.querySelector('[data-addon-label]');
      if (addonLabel && !addonButton.disabled) addonLabel.textContent = state.addonSelected ? 'Hozzáadva' : 'Hozzáadom';
      const mark = addonButton?.querySelector('.pp-addon__check');
      if (mark) mark.textContent = state.addonSelected ? '✓' : '+';
      root.querySelectorAll('[data-total-price],[data-sticky-price]').forEach((node) => {
        node.textContent = state.addonSelected && config.addonPrice
          ? `${config.totalToday} + ${config.addonPrice}`
          : config.totalToday;
      });
      const subline = root.querySelector('[data-buy-subline]');
      if (subline) subline.textContent = state.addonSelected
        ? `${config.totalToday} + ${config.addonPrice} ma · majd ${config.mentorPrice}/hó`
        : `${config.totalToday} ma · majd ${config.mentorPrice}/hó`;
      void baseMinor; void mentorMinor;
    }

    function toggleAddon() {
      if (addonButton?.disabled) return;
      if (!config.addonAvailable || !Number(config.addonVariantId)) {
        showToast('A 24 órás gyorsítás jelenleg nem elérhető.');
        return;
      }
      state.addonSelected = !state.addonSelected;
      addonButton?.classList.toggle('is-active', state.addonSelected);
      addonButton?.setAttribute('aria-pressed', String(state.addonSelected));
      updatePriceUI();
      trackEvent(state.addonSelected ? 'addon_selected' : 'addon_removed', {});
    }

    async function trackEvent(eventType, metadata = {}) {
      if (!state.sessionToken || !apiBase()) return;
      try {
        await apiRequest('/api/funnel/event', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ sessionToken: state.sessionToken, eventType, metadata }),
        });
      } catch (_) {}
    }

    function validateProducts() {
      if (!config.mainAvailable || !Number(config.mainVariantId)) return 'A 7 napos program jelenleg nem elérhető.';
      if (!config.mentorAvailable || !Number(config.mentorVariantId)) return 'A Mentor-termék jelenleg nem elérhető.';
      if (!Number(config.sellingPlanId)) return 'Az AI Mentor előfizetés selling planje nincs beállítva.';
      return '';
    }

    async function buy(trigger) {
      if (state.purchasePending) return;
      const validationError = validateProducts();
      if (validationError) { showToast(validationError); return; }
      state.purchasePending = true;
      const original = trigger?.innerHTML;
      if (trigger) { trigger.disabled = true; trigger.textContent = 'Előkészítjük a fizetést…'; }

      const sessionProperty = String(state.sessionToken || `personal_${Date.now()}`).slice(0, 250);
      const properties = {
        _shift_session_id: sessionProperty,
        _shift_plan_token: String(planToken || '').slice(0, 250),
        _shift_funnel: 'personal-plan',
      };
      const items = [
        { id: Number(config.mainVariantId), quantity: 1, properties },
        { id: Number(config.mentorVariantId), quantity: 1, selling_plan: Number(config.sellingPlanId), properties },
      ];
      if (config.giftAvailable && Number(config.giftVariantId)) {
        items.push({ id: Number(config.giftVariantId), quantity: 1, properties: { _shift_gift: 'journal', _shift_session_id: sessionProperty } });
      }
      if (state.addonSelected && config.addonAvailable && Number(config.addonVariantId)) {
        items.push({ id: Number(config.addonVariantId), quantity: 1, properties: { _shift_addon: '24-hour', _shift_session_id: sessionProperty } });
      }

      const routeRoot = (window.Shopify?.routes?.root || root.dataset.cartRoot || '/').replace(/\/?$/, '/');
      try {
        const response = await fetch(`${routeRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'CART_ADD_FAILED');
        await trackEvent('checkout_started', { includeAddon: state.addonSelected, source: 'personal-plan' });
        window.location.assign(`${routeRoot}checkout`);
      } catch (error) {
        console.error('Personal plan cart error', error);
        showToast('Nem sikerült megnyitni a fizetést. Próbáld újra.');
        state.purchasePending = false;
        if (trigger) { trigger.disabled = false; trigger.innerHTML = original; }
      }
    }


    planChatOpen?.addEventListener('click', openPlanChat);
    root.querySelectorAll('[data-plan-chat-close]').forEach((button) => button.addEventListener('click', closePlanChat));
    planChatQuick?.querySelectorAll('[data-plan-chat-prompt]').forEach((button) => {
      button.addEventListener('click', () => sendPlanChat(button.dataset.planChatPrompt || button.textContent || ''));
    });
    planChatInput?.addEventListener('input', () => {
      planChatInput.style.height = 'auto';
      planChatInput.style.height = `${Math.min(112, planChatInput.scrollHeight)}px`;
      if (planChatSend) planChatSend.disabled = state.planChatPending || state.planChatRemaining <= 0 || !planChatInput.value.trim();
    });
    planChatInput?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        planChatForm?.requestSubmit();
      }
    });
    planChatForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      sendPlanChat(planChatInput?.value || '');
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && planChatLayer && !planChatLayer.hidden) closePlanChat();
    });
    updatePlanChatRemaining(state.planChatRemaining);
    if (planChatOpen) window.setTimeout(() => planChatOpen.classList.add('has-nudge'), 9000);

    addonButton?.addEventListener('click', toggleAddon);
    buyButton?.addEventListener('click', () => buy(buyButton));
    stickyBuy?.addEventListener('click', () => {
      offerSection?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => buy(buyButton), 420);
    });

    if (stickyBar && offerSection && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > 480);
      }, { threshold: 0.15 });
      observer.observe(offerSection);
    }

    updatePriceUI();
    startTimer();
    loadPlan();
  }

  function initAll(scope = document) { scope.querySelectorAll(ROOT_SELECTOR).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
